import * as React from 'react'
import * as XLSX from 'xlsx'
import { useSelector } from 'react-redux'
import { Box, Stack, styled, Button } from '@mui/material'
import { Typography as MIUTypography, Divider } from '@mui/material'
import { Download, ArticleOutlined } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import Footer from './Footer'
import { info, widthCol } from './info'
import Introduction from './Introduction'
import ConteinerBox from './ContainerBox'
import { imagesGallery } from '../../utils'
import {
  getReportHeaderPublic,
  getReportDataPublic,
  getTreeRegisterCount,
  updateDownloadCounter,
  getDownloadCounter,
} from '../../services'

import logo_unl from '../../assets/images/logo_unl.png'
import logo_cis from '../../assets/images/logo-cis-2.png'
import logo_cif from '../../assets/images/logo_cif.png'

import ImagenGallery from '../../components/ImageGallery'
import _ from 'lodash'

const styleStack = {
  direction: 'column',
  alignItems: 'center',
  px: '5vw',
  spacing: 1,
  width: '100%',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const styleImages = {
  pt: 2,
  pb: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  width: '100%',
}

const buttonStyle = {
  color: '#004280',
  borderColor: '#004280',
  borderBottomWidth: 'thick',
  borderBottomColor: '#004280',
  fontWeight: 600,
  fontSize: '0.8rem',
  width: '81%',
  '&:hover': {
    borderBottomWidth: 'thick',
    borderBottomColor: '#37cd27',
    backgroundColor: 'transparent',
    fontSize: '0.8rem',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.07rem #004280',
  },
}

const styleNumber = {
  fontWeight: 650,
  color: '#000',
  textDecoration: 'underline overline #37cd27',
}

const InformationPage = props => {
  const title1 = 'Artículos'
  const title2 = 'Inventario'
  const _state = useSelector(state => state.drawerLeft)
  const [loading, setLoading] = React.useState(false)
  const [countTree, setCountTree] = React.useState(5000)
  const [downloadCounted, setDownloadCounted] = React.useState(0)
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)

  const styleBox = {
    marginLeft: _state.open ? _state.drawerWidth : 0,
    marginTop: _state.drawerHeight,
    height: _state.contentBox,
    width: 'inherit',
    overflow: 'auto',
    scrollBehavior: 'smooth',
    background: `radial-gradient(81% 55.9% at 50% 55.2%, rgba(253, 119, 2, 0.05) 0%, rgba(255, 255, 255, 0) 100%)`,
  }

  const handleDownloadDB = () => {
    setLoading(true)
    getReportDataPublic()
      .then(async rows => {
        const cols = await getReportHeaderPublic()
        const worksheet2 = XLSX.utils.json_to_sheet(info(countTree))
        const worksheet = XLSX.utils.json_to_sheet(rows.resultALL)
        const workbook = XLSX.utils.book_new()
        const columnsname = _.map(cols, 'headerName')
        const columnsname2 = ['UNIVERSIDAD NACIONAL DE LOJA']
        XLSX.utils.book_append_sheet(workbook, worksheet2, 'Info')
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Inventario Loja')
        XLSX.utils.sheet_add_aoa(worksheet2, [columnsname2], { origin: 'A1' })
        XLSX.utils.sheet_add_aoa(worksheet, [columnsname], { origin: 'A1' })
        worksheet2['!cols'] = [{ wch: 190 }]
        worksheet['!cols'] = widthCol
        XLSX.writeFile(workbook, 'Árboles Loja - Inventario.xlsx', {
          compression: true,
        })
      })
      .catch(err => {
        window.alert('Oops! Hubo un problema, inténtelo nuevamenta... :)')
      })
      .finally(() => {
        setLoading(false)
        setDownloadCounted(downloadCounted + 1)
        updateDownloadCounter()
      })
  }

  React.useEffect(() => {
    function handleWindowResize() {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  React.useEffect(() => {
    getTreeRegisterCount()
      .then(quantityTrees => setCountTree(quantityTrees))
      .catch(err => console.log(err))
  }, [])

  React.useEffect(() => {
    getDownloadCounter()
      .then(count => setDownloadCounted(count))
      .catch(err => console.log(err))
  }, [])

  const Imagen = ({ src, alt, height = 'calc(7vw)', maxHeight = 60, h = '100%' }) => (
    <Box component="div" sx={{ height, maxHeight }}>
      <img src={src} alt={alt} height={h} />
    </Box>
  )

  return (
    <Box style={styleBox}>
      <Box sx={styleImages}>
        <Imagen src={logo_cif} alt="Logo CIF" />
        <Imagen src={logo_unl} alt="Logo UNL" maxHeight={62} />
        <Imagen src={logo_cis} alt="Logo CIS" maxHeight={65} />
      </Box>
      <Stack {...styleStack}>
        <Box>
          <Typography istitle="true">Proyecto 17-DI-FARNR-2021</Typography>
          <Typography istitle="true" sx={{ textTransform: 'uppercase' }}>
            “Dinámica de crecimiento y servicios ecosistémicos del arbolado urbano de la
            ciudad de Loja”
          </Typography>
        </Box>

        <ImagenGallery images={imagesGallery} wWidth={windowWidth} />

        <Introduction />

        <Box pt={3} pb={2}>
          <Typography istitle="true">ACCESO LIBRE A LA INFORMACIÓN</Typography>
        </Box>
        <ConteinerBox
          widthMin={200}
          wWidth={windowWidth}
          defaultWidthMin={810}
          defaultWidth="810px"
          title={title1}>
          <Typography
            component={`div`}
            sx={{ fontWeight: 500, color: '#000', pt: 1, px: 2 }}>
            <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <Button
                target="_blank"
                href="https://doi.org/10.54753/blc.v13i2.1886"
                variant="container"
                endIcon={<ArticleOutlined />}>
                1. Caracterización florística y estructura del arbolado urbano de la
                ciudad de Loja
              </Button>
            </Box>
          </Typography>
          <Typography
            component={`div`}
            sx={{ fontWeight: 500, color: '#000', pb: 1, px: 2 }}>
            <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <Button
                target="_blank"
                href="https://doi.org/10.54753/cedamaz.v13i1.1933"
                variant="container"
                endIcon={<ArticleOutlined />}>
                2. Aplicación web para la gestión del arbolado urbano de la ciudad de Loja
              </Button>
            </Box>
          </Typography>
        </ConteinerBox>

        <Box pt={2} pb={2}>
          <Typography sx={{ fontWeight: 500 }}>
            La base de datos actualmente contine{' '}
            <span style={styleNumber}>{countTree}</span> registros recolectados y
            verificados por los investigadores del proyecto. <br />
            Accedar al conjunto de datos en Excel:
          </Typography>
        </Box>

        <ConteinerBox
          widthMin={200}
          wWidth={windowWidth}
          title={title2}
          defaultWidthMin={330}
          defaultWidth="275px"
          pb={2}>
          <Box pt={2}>
            <Box sx={{ textAlign: 'center' }}>
              <LoadingButton
                variant="outlined"
                startIcon={<Download />}
                loading={loading}
                loadingIndicator="Procesando..."
                onClick={handleDownloadDB}
                sx={buttonStyle}>
                DATASET
              </LoadingButton>
              {Boolean(downloadCounted) && (
                <Box sx={{ fontSize: 12 }}>Descargas: {downloadCounted}</Box>
              )}
            </Box>
          </Box>
        </ConteinerBox>
      </Stack>

      <Footer windowWidth={windowWidth} />
      <Divider sx={{ height: '5px', background: '#25a52e' }} />
      <Divider sx={{ height: '5px', background: '#de0309' }} />
      <Divider />
      <Box
        sx={{
          height: '3em',
          background: '#004280',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Typography
          istitle="true"
          sx={{
            textTransform: 'uppercase',
            color: '#fff',
            fontFamily: 'monospace',
            fontSize: '0.8em',
          }}>
          ArbolQR - UNL - LOJA - ECUADOR
        </Typography>
      </Box>
    </Box>
  )
}

export default InformationPage
